// extracted by mini-css-extract-plugin
export default {"detail":"DbLink-module_detail__10IAs","link":"DbLink-module_link__2I_vM","image":"DbLink-module_image__isX7T"};